import './cards.sass'
import {Card, Image, Skeleton} from "antd"
import {ReactComponent} from "../../app"
import {CheckCircleFilled, CloseCircleFilled} from "@ant-design/icons"
import dayjs from "dayjs"
import "dayjs/locale/cs"
import Wave from "antd/es/_util/wave"

dayjs.locale("cs")

export default class RewardItemCard extends ReactComponent {
  state = {
    appliedRewards: true,
  }

  render () {
    const activeReward = this.props.type === "active" ? 'Aktivní odměna' : this.state.appliedRewards ? 'Využitá odměna' : 'Nevyužitá odměna'

    return (
      <Wave>
        <Card
          className={this.className(['reward-item-card mb-2', this.props.type === "active" ? "" : "reward-item-applied"])}
          cover={this.props.reward?.reward.image_urls.length ? (
          <Image preview={false} src={this.props.reward?.reward.image_urls[0]}/>
        ) : (
          <Skeleton.Image/>
        )}
          onClick={this.props.openRewardDetail}
          >

          <Card.Meta
            title={
              <>
                <h3>{this.props.reward?.reward.name}</h3>
                <h6>{this.props.reward?.reward.subtitle}</h6>
              </>
            }
            description={
              <>
                <div>
                  {this.props.type === "active" || this.state.appliedRewards ? <CheckCircleFilled/> : <CloseCircleFilled/>}
                  <span className='reward-text'>{activeReward}</span>
                </div>

                <div>Platnost do:
                  <span className='reward-text pl-02'>{dayjs(this.props.reward?.valid_to).format("D. M. YYYY")}</span>
                </div>
              </>
            }
          />

        </Card>
      </Wave>
    )
  }
}